import { Box, Grid, Typography, useTheme } from "@mui/material"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { Fragment, useEffect, useState } from "react"
import styles from "../MenuImage/menuImage.module.scss"
import { getWeeklyCategoryAction } from "redux/superAdmin/actions"
import { useDispatch, useSelector } from "react-redux"
import image from "assets/images/imagePlaceholder.png"
import { AddOutlined } from "@mui/icons-material"
import AddNewCategoryModal from "./addNewCategoryModal"
import EditOutlinedIcon from "@mui/icons-material/EditOutlined"

const WeeklyCategoryImage = () => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [edit, setEdit] = useState(false)
  const [data, setData] = useState({})
  const { weeklyCategory } = useSelector((store) => store.superAdmin)

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Weekly Category Management"
    dispatch(getWeeklyCategoryAction())
  }, [])

  const handleEdit = (category) => {
    setOpen(true)
    setEdit(true)
    setData(category)
  }

  const onClose = () => {
    setOpen(false)
    setEdit(false)
    setData({})
  }

  return (
    <Fragment>
      <AddNewCategoryModal open={open} onClose={() => onClose()} isEdit={edit} data={data} />
      <Grid container>
        <Grid item xs={12}>
          <Header title="Weekly Category Management" breadCrumbs={breadCrumbs}>
            <AppButton
              sx={{ padding: "13px 16px" }}
              startIcon={<AddOutlined />}
              onClick={() => setOpen(true)}>
              Add New Category
            </AppButton>
          </Header>
        </Grid>
      </Grid>
      <Grid container item ml={4} xs={12} lg={11}>
        {weeklyCategory?.map((category, index) => (
          <Grid item key={index} xs={6} mb={8} sx={{ maxWidth: "fit-content" }}>
            <Box className="d-flex" sx={{ gap: "154px" }}>
              <Grid item className={styles.category}>
                <Typography
                  variant="body1Regular"
                  sx={{ fontWeight: "600" }}
                  color={theme.palette.secondary.main}>
                  Category {index + 1}
                </Typography>
              </Grid>
              <Grid item>
                <AppButton
                  startIcon={<EditOutlinedIcon />}
                  onClick={() => handleEdit(category)}
                  sx={{ padding: "6px 16px" }}>
                  Edit
                </AppButton>
              </Grid>
            </Box>

            <Grid item mt={4} mb={3}>
              <img
                src={category?.image_url || image}
                alt="i"
                loading="eager"
                className={styles.image}
              />
            </Grid>
            <Grid item>
              <Grid item>
                <Typography variant="body1Regular" color={theme.palette.text.secondary}>
                  Weekly Category Name
                </Typography>
              </Grid>
              <Grid item mt={1}>
                <Typography variant="body1Regular">{category?.name}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Fragment>
  )
}

export default WeeklyCategoryImage
